import React from "react";
import { connect } from "react-redux";
import history from "../../history/history";
import { PillAnchor } from "./styles";
import {
  showUpdateButton,
  setOldState,
  setExchangeFlagAndData,
  setFromNewPools,
  setToNewPools,
  switchTabExchange
} from "../../Epics/Investments/Pages/RecommendFlow/actions";
import _ from "lodash";
import { replacer } from "../../utils/nameFormatter";
import { recordError } from "../../utils/commonUtil";
import pencil from "../../assets/icons/edit.svg";
import pencil_disable from "../../assets/icons/edit_disable.svg";
import PropTypes from "prop-types";
import { editLinkToPillsDerivedStates } from "../selectors";

export const routeTo = props => {
  try {
    const currentUrl = history.location.pathname;
    if (props.active) {
      history.push({
        pathname: props.linkPathname,
        state: { active: props.active, advisorType: props.advisorType }
      });
    } else {
      history.push(props.linkPathname);
    }
    if (props.analyticsTracking) props.analyticsTracking(currentUrl);
    window.scrollTo(0, 0);
    if (props.pageName === "viewExchanges" && props.stepNo === 1) {
      props.setExchangeFlagAndData(props.exchangeDataOT);
      let pools = {};
      if (props.scheduleType === "recurring") {
        props.tabExchange("recurring");
        props.exchangeDataOT.recurringExchange.exchangeFrom.map(each => {
          let percent = 0,
            unit = 0,
            value = 0;
          if (props.allocationType === "PERCENT") {
            percent = each.percentage;
            value = (each.availableBalance * each.percentage) / 100;
            unit = each.pricePerUnit * value;
          }
          let obj = {
            Dollars: value.toString(),
            Units: unit.toString(),
            Percentage: each.percentage
          };
          let name = replacer(each.pool);
          const newObj = _.defaults({ [`${name}`]: obj });
          let newPools = _.merge(pools, newObj);
          props.setFromNewPools(newPools);
        });
      } else {
        props.exchangeDataOT.singleExchange.exchangeFrom.map(each => {
          let percent = 0,
            unit = 0,
            value = 0;
          if (props.instructionType === "PERCENT") {
            percent = each.percentage;
            value = (each.availableBalance * each.percentage) / 100;
            unit = each.pricePerUnit * value;
          }
          let obj = {
            Dollars: value.toString(),
            Units: unit.toString(),
            Percentage: each.percentage
          };
          let name = replacer(each.pool);
          const newObj = _.defaults({ [`${name}`]: obj });
          let newPools = _.merge(pools, newObj);
          props.setFromNewPools(newPools);
        });
      }
    } else if (props.pageName === "viewExchanges" && props.stepNo === 2) {
      props.setExchangeFlagAndData(props.exchangeDataOT);
      let pools = {};
      if (props.scheduleType != "recurring") {
        props.exchangeDataOT.singleExchange.exchangeTo.map(each => {
          let obj = {
            Percentage: each.percentage
          };
          let name = replacer(each.pool);
          const newObj = _.defaults({ [`${name}`]: obj });
          let newPools = _.merge(pools, newObj);
          props.setToNewPools(newPools);
        });
      } else {
        props.exchangeDataOT.recurringExchange.exchangeTo.map(each => {
          let obj = {
            Percentage: each.percentage
          };
          let name = replacer(each.pool);
          const newObj = _.defaults({ [`${name}`]: obj });
          let newPools = _.merge(pools, newObj);
          props.setToNewPools(newPools);
        });
      }
    } else {
      props.setUpdateButton(props.pageName);
      props.setOldState(props.pageName);
    }
  } catch (error) {
    recordError(error);
  }
};
function EditLinkToPill(props) {
  if (!props.activeConfirmation) {
    return (
      <React.Fragment data-test="edit-link">
        {props.isDisabled ? (
          <PillAnchor
            id={props.prefixId && `${props.prefixId}anrEditDisabled`}
            disabled={true}
            onClick={() => routeTo(props)}
          >
            <span style={{ color: "#d9d9d9" }}>Edit</span>
            <img src={pencil_disable} className="ml-05" alt="pencil_disable" />
          </PillAnchor>
        ) : (
          <PillAnchor
            id={props.prefixId && `${props.prefixId}anrEditEnabled`}
            disabled={false}
            onClick={() => props.onClick ? props.onClick() : routeTo(props)}
            editBtn
          >
            <span>Edit</span>
            <img src={pencil} className="ml-05" alt="pencil" />
          </PillAnchor>
        )}
     </React.Fragment>
    );
  }
  return null;
}

EditLinkToPill.propTypes = {
  active: PropTypes.string,
  activeConfirmation: PropTypes.bool,
  advisorType: PropTypes.string,
  allocationType: PropTypes.string,
  analyticsTracking: PropTypes.func,
  exchangeDataOT: PropTypes.object,
  instructionType: PropTypes.string,
  isDisabled: PropTypes.bool,
  linkPathname: PropTypes.string,
  pageName: PropTypes.string,
  scheduleType: PropTypes.string,
  setExchangeFlagAndData: PropTypes.func,
  setFromNewPools: PropTypes.func,
  setOldState: PropTypes.func,
  setToNewPools: PropTypes.func,
  setUpdateButton: PropTypes.func,
  stepNo: PropTypes.number,
  tabExchange: PropTypes.func
};

const mapStateToProps = state => {
  return {
...editLinkToPillsDerivedStates(state.toJS())
  };
};

export const mapDispatchToProps = dispatch => ({
  setUpdateButton: pageName => dispatch(showUpdateButton(pageName)),
  setOldState: propPageName => dispatch(setOldState(propPageName)),
  setExchangeFlagAndData: data => dispatch(setExchangeFlagAndData(data)),
  setFromNewPools: data => dispatch(setFromNewPools(data)),
  setToNewPools: data => dispatch(setToNewPools(data)),
  tabExchange: activeKey => dispatch(switchTabExchange(activeKey))
});
export default connect(mapStateToProps, mapDispatchToProps)(EditLinkToPill);
